import BaseInput from './BaseInput'

export default class StringInput extends BaseInput {
}
